import React, { memo } from "react";

// AWS
import { S3Image } from "aws-amplify-react";
import { format } from "date-fns";

function ItemCard({ item, openModal }) {
  return (
    <div className="bg-white shadow-xl" onClick={() => openModal(item)}>
      <S3Image
        imgKey={item.img.length > 0 ? item.img.filter((img) => img)[0] : null}
        className="w-full h-auto"
      />
      <div className="m-2 mb-0 text-gray-700 font-bold text-base">
        {item.name}
      </div>
      <div className="mx-2  text-blue-500 font-medium text-sm">
        คะแนนที่ใช้แลก {item.price}
      </div>
      <div className="m-2 mt-0 text-gray-400 font-medium text-xs">
        อัพเดทเมื่อ {format(new Date(item.timestamp), "dd/MM/yyyy")}
      </div>
    </div>
  );
}

export default memo(ItemCard);
